import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Note = ApplicationRecord.extend({
  static: {
    jsonapiType: 'notes',
  },
  attrs: {
    note: attr(),
    priority: attr(),
    createdAt: attr(),
    schoolId: attr(),
    followUpDate: attr(),
    visitDate: attr(),
    school: belongsTo(),
  },
})

export default Note
